import { SummaryTracking } from "@/lib/tracking/summary";
import { RelativeComponentLoader } from "@/components/loader";
import { getSummaryPageOpportunities } from "@/helpers/apis";
import { Badge, NumberFormatter } from "@/uiCore";
import { Alert } from "@altimateai/lego";
import { Card } from "@altimateai/lego";
import { useQuery } from "@tanstack/react-query";
import classes from "../summary.module.scss";
import { Link } from "react-router-dom";
import { useAppState } from "@/modules/app/useAppContext";
import dayjs from "dayjs";
import { useEffect } from "react";

const OpportunitiesList = ({ instanceId }: { instanceId: string }) => {
  const { currency } = useAppState();
  const { isFetching, data, error } = useQuery({
    queryKey: [`summary-opportunities`, instanceId],
    queryFn: () => getSummaryPageOpportunities({ period: "month", instance_id: instanceId }),
  });

  useEffect(() => {
    if (error) SummaryTracking.opportunitiesLoadFailed(error);
  }, [error]);

  if (isFetching) {
    return <RelativeComponentLoader label="Loading opportunities..." />;
  }

  if (error) {
    return <Alert variant="destructive">Failed to load opportunities data</Alert>;
  }

  return (
    <div
      className={`al-grid al-grid-cols-1 sm:al-grid-cols-2 md:al-grid-cols-3 lg:al-grid-cols-4 al-gap-4 ${classes.opportunitiesList}`}
    >
      {data?.map(opportunity => {
        const searchParams = new URLSearchParams(opportunity?.params);
        searchParams.set("start_date", dayjs().subtract(28, "day").toDate().toISOString());
        searchParams.set("end_date", dayjs().toDate().toISOString());
        if (instanceId && instanceId !== "all") {
          searchParams.set("instance", instanceId);
        }
        return (
          <div key={opportunity.label}>
            <Card className="al-p-4">
              <div className="al-flex al-flex-col al-gap-3">
                <Link
                  to={`/discover?${searchParams.toString()}`}
                  onClick={() =>
                    SummaryTracking.opportunityClicked({
                      opportunity_label: opportunity.label,
                      savings_amount: opportunity.value,
                    })
                  }
                >
                  <Badge tooltip={""} pill>
                    <NumberFormatter
                      options={{ currency, maximumFractionDigits: 1 }}
                      value={opportunity.value}
                    />
                  </Badge>
                  <div style={{ flex: 1 }} className="text-truncate-two-lines">
                    {opportunity.label}
                  </div>
                </Link>
              </div>
            </Card>
          </div>
        );
      })}
    </div>
  );
};

export default OpportunitiesList;
